import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ZoomIn, X } from "lucide-react";
import { useLang } from "../../config/i18n";

export const Sigil = ({ spirit, size = "md", withZoom = true }) => {
  const [zoomed, setZoomed] = useState(false);
  const { t } = useLang();
  const dim = size === "lg" ? "w-48 h-48 sm:w-60 sm:h-60" : "w-24 h-24";

  return (
    <>
      <div className={`relative ${dim} mx-auto`} data-testid={`sigil-${spirit.slug}`}>
        <div className="absolute -inset-2 rounded-full border border-[#C5A059]/45" />
        <div className="absolute inset-0 rounded-full bg-[#0D0D10] overflow-hidden flex items-center justify-center">
          <img
            src={spirit.sigil}
            alt={`Sigilo de ${spirit.name} — Ars Goetia`}
            loading="lazy"
            className="w-[78%] h-[78%] object-contain sigil-gold"
          />
        </div>
        {withZoom && (
          <button
            data-testid={`sigil-zoom-btn-${spirit.slug}`}
            onClick={() => setZoomed(true)}
            className="absolute -bottom-1 left-1/2 -translate-x-1/2 translate-y-full mt-2 inline-flex items-center gap-1.5 text-[10px] tracking-[0.18em] uppercase text-[#C5A059] hover:text-[#E9BE62] transition-colors whitespace-nowrap"
          >
            <ZoomIn size={13} /> {t.goetia.zoom}
          </button>
        )}
      </div>

      <AnimatePresence>
        {zoomed && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-[#0A0A0C]/95 backdrop-blur-md flex items-center justify-center p-6"
            onClick={() => setZoomed(false)}
            data-testid="sigil-zoom-overlay"
          >
            <button
              className="absolute top-5 right-5 w-11 h-11 flex items-center justify-center text-[#C5A059] border border-[#C5A059]/40 rounded-full"
              aria-label="Fechar"
              data-testid="sigil-zoom-close"
            >
              <X size={20} />
            </button>
            <motion.div
              initial={{ scale: 0.85 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="relative max-w-[85vw] max-h-[80vh] aspect-square"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="absolute -inset-4 rounded-full border border-[#C5A059]/50" />
              <img
                src={spirit.sigil}
                alt={`Sigilo de ${spirit.name} ampliado`}
                className="w-full h-full object-contain sigil-gold rounded-full bg-[#0D0D10]"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
